/* @flow */

import React, { Component } from 'react';
import { Dimmer } from 'semantic-ui-react';
import ResourceImage from 'shared/components/ResourceImage';

type Props = {
  resource?: BucketResource,
  children?: Element,
};

type State = {
  active: boolean,
};

class ResourceDimmer extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      active: false,
    };
  }

  handleShow = () => this.setState({ active: true });
  handleHide = () => this.setState({ active: false });

  render() {
    const { resource, children } = this.props;
    const { active } = this.state;

    const dimmerActive = resource && active;

    return (
      <Dimmer.Dimmable
        as={ResourceImage}
        resource={resource}
        dimmed={dimmerActive}
        dimmer={{ active: dimmerActive, content: children }}
        onMouseEnter={this.handleShow}
        onMouseLeave={this.handleHide}
      />
    );
  }
}

export default ResourceDimmer;



// WEBPACK FOOTER //
// ./src/shared/components/ResourceDimmer.js